exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctt-content{padding:15px 10px}.p-width--100{width:100%}", ""]);

// exports
